import { render, staticRenderFns } from "./aboutPage.vue?vue&type=template&id=7bb08f66&scoped=true&"
import script from "./aboutPage.vue?vue&type=script&lang=js&"
export * from "./aboutPage.vue?vue&type=script&lang=js&"
import style0 from "./aboutPage.vue?vue&type=style&index=0&id=7bb08f66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb08f66",
  null
  
)

export default component.exports